// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__QEzLi","footer":"Form_footer__3pZFm"};